<template>
  <div class="q-mt-lg">
    <div
      class="q-ml-lg q-my-md text-brand-1 text-weight-medium"
      style="font-size: 16px"
    >
      Lista de Produtos Selecionados.
    </div>
    <q-table
      flat
      table-header-style="background-color: #d9effc"
      :rows="rows"
      :columns="columns"
      title-class="text-brand-5 text-weight-bold"
      :loading="disable"
      dense
      class="tabela-tamanho-fixo"
      :filter="filtrar"
      hide-pagination
      v-model:pagination="pagination"
      :rows-per-page-options="[0]"
      @request="handleRequest"
    >
      <template #body-cell-remover="props">
        <q-td>
          <div class="row">
            <q-btn
              @click="remove(props.rowIndex)"
              round
              flat
              color="negative"
              icon="sym_o_close"
            />
          </div>
        </q-td>
      </template>
      <template #body-cell-unit="props">
        <q-td>
          <div class="row">
            <q-input dense outlined v-model="props.row.unit"> </q-input>
          </div>
        </q-td>
      </template>
      <template #body-cell-quantidade="props">
        <q-td>
          <div class="row">
            <q-input dense outlined v-model="props.row.pedido"> </q-input>
          </div>
        </q-td>
      </template>
    </q-table>
    <div class="row justify-start q-mt-md" v-if="rows.length > 0">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>
    <q-btn
      @click="enviar"
      label="Adicionar"
      class="q-ml-md q-mt-lg"
      style="border-radius: 8px; background-color: #21324a; color: white"
      icon="local_grocery_store"
    />
  </div>
</template>

<script>
const columns = [
  {
    name: "remover",
    label: "Remover",
    field: "remover",
    align: "left",
  },

  {
    name: "product_code",
    label: "Código",
    field: "product_code",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "product_name",
    label: "Descrição",
    field: "product_name",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },

  {
    name: "unit",
    label: "Vlr. Unit.",
    field: "unit",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "quinzed",
    label: "Cons. 15d	",
    field: "quinzed",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "trintad",
    label: "Cons. 30d	",
    field: "trintad",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "tres_meses",
    label: "Cons. 3m",
    field: "tres_meses",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },

  {
    name: "amount",
    label: "Atual",
    field: "amount",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "max_amount",
    label: "Máx",
    field: "max_amount",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "quantidade",
    label: "Qtd. Pedido",
    field: "quantidade",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
];

import { ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useQuasar } from "quasar";
export default {
  props: ["atualizar", "selecionados"],
  setup(props, { emit }) {
    const store = useStore();
    const $q = useQuasar();
    const rows = ref([]);
    const disable = ref(false);

    const route = useRoute();

    const id = route.params.id;

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 25,
      rowsNumber: 15,
    });

    const remove = async (index) => {
      rows.value.splice(index, 1);
    };

    const enviar = async () => {
      let produtos = [];

      rows.value.forEach((e) => {
        produtos.push({
          amount: e.pedido,
          ca_code: e.ca_code,
          id: e.product_id,
          last_price: null,
          max_amount: e.max_amount,
          price: e.unit,
          product_code: e.product_code,
          product_name: e.product_group_name,
          stock: e.amount,
          quinze_dias: e.quinzed,
          trinta_dias: e.trintad,
          tres_meses: e.tres_meses,
        });
      });

      try {
        store.dispatch("compras/adicionarProdutosManual", {
          purchase_id: id,
          products: produtos,
        });

        $q.notify({
          message: "Adicionado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        emit("atualizar");

        while (rows.value.length) {
          rows.value.pop();
        }
      } catch (error) {
        $q.notify({
          message: "Erro a o adicionar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => props.atualizar,
      () => {
        rows.value = props.selecionados;
        disable.value = false;
      }
    );

    return {
      pagination,
      rows,
      disable,
      columns,
      remove,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      enviar,
    };
  },
};
</script>

<style>
.align {
  align-items: center;
}
</style>
